export default __webpack_public_path__ + "static/media/deepdao_new_header_logo.d552b9c1.svg";